import { FC } from 'react';
import { ButtonsGroup } from './components/ButtonsGroup';
import { InputGroup } from './components/InputGroup';
import { SelectGroup } from './components/SelectGroup';
import { Card } from '@components/atoms/Card';
import { CheckboxGroup } from './components/CheckboxGroup';
import { SmallComponents } from './components/SmallComponents';
import { ModalGroup } from './components/ModalGroup';
import { TabGroup } from './components/TabGroup';

export const UiComponents: FC = () => {
  return (
    <div className="flex flex-col gap-4 transition-colors duration-200">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
        Components
      </h1>
      <div className="flex flex-col gap-6">
        <SmallComponents />
        <ModalGroup />
        <ButtonsGroup />
        <InputGroup />
        <SelectGroup />
        <TabGroup />
        <Card>
          <h2 className="text-lg text-gray-900 dark:text-white font-bold">
            Card
          </h2>
        </Card>
        <CheckboxGroup />
      </div>
    </div>
  );
};
